module.exports = __webpack_public_path__ + "img/content_right2.433a31af.png";